import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const TwoImageComponent = () => {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  const text = "Aceasta este prima editie a unui eveniment pe care ne dorim sa-l transformam intr-o traditie pentru asociatia noastra. Multumim tuturor participantilor pentru prezenta, deschidere si pentru momentele pline de sens pe care le-am creat impreuna!";
  
  // Imagini demo - înlocuiește cu pozele tale
  const images = [
    {
      id: 1,
      src: "/images/echipa Psi.jpg",
      alt: "Eveniment imagine 1"
    },
    {
      id: 2,
      src: "/images/poza grup.jpg",
      alt: "Eveniment imagine 2"
    }
  ];
  
  const openFullscreen = (image) => {
    setFullscreenImage(image);
  };
  
  const closeFullscreen = () => {
    setFullscreenImage(null);
  };
  
  return (
    <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '16px' }}>
      {/* Layout principal */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isLargeScreen ? 'row' : 'column',
        gap: '32px',
        alignItems: 'flex-start'
      }}>
        {/* Text - stanga pe ecrane mari */}
        <div style={{ 
          flex: '1',
          minWidth: '0',
          paddingLeft: '20px'
        }}>
          <p style={{ 
            color: 'black',
            lineHeight: '1.7',
            fontSize: '16px',
            textAlign: 'justify',
            paddingRight: '15px',
            margin: '0'
          }}>
            {text}
          </p>
        </div>
        
        {/* Imagini - dreapta pe ecrane mari, jos pe ecrane mici/medii */}
        <div style={{ 
          flex: '1',
          width: '100%'
        }}>
          <div style={{ 
            display: 'flex',
            gap: '16px',
            width: '100%'
          }}>
            {images.map((image) => (
              <div
                key={image.id}
                onClick={() => openFullscreen(image)}
                style={{
                  flex: '1',
                  height: isLargeScreen ? '140px' : '180px',
                  cursor: 'pointer',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block'
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Modal pentru fullscreen */}
      {fullscreenImage && (
        <div 
          onClick={closeFullscreen}
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: '9999',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px'
          }}
        >
          <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <button
              onClick={closeFullscreen}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                zIndex: '10',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                border: 'none',
                borderRadius: '50%',
                padding: '8px',
                cursor: 'pointer',
                color: 'white'
              }}
            >
              <X size={24} />
            </button>
            <img
              src={fullscreenImage.src}
              alt={fullscreenImage.alt}
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: '90vw',
                maxHeight: '90vh',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                borderRadius: '8px'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TwoImageComponent;